import * as React from 'react';
import { RecentlyViewedProducts as RecentlyViewedProducts$1 } from '@grandvisionhq/products';
import { compose } from '@grandvisionhq/utils';
import { withAnchor } from '../../hocs/with-anchor.js';
import '@swc/helpers';
import '@grandvisionhq/state';
import '@bloomreach/react-sdk';
import '../../context/configuration.js';
import '@bloomreach/spa-sdk';
import '@grandvisionhq/search';
import 'jsonpointer';
import '@grandvisionhq/common';
import '../../utils/http-client.js';
import '@grandvisionhq/lib-utils-html';
import '@grandvisionhq/content';
import '@grandvisionhq/graphql';
import '../../operations/mutations/signup-promotion.js';
import '../../operations/mutations/subscribe-newsletter.js';
import '../../operations/mutations/subscribe-newsletter-opt-in.js';
import '@grandvisionhq/svc-tealium/events';
import { useBloomreachPageName } from '../../hooks/use-bloomreach-page-name.js';
import { useBloomreachSiteLogos } from '../../hooks/use-bloomreach-site-logos.js';
import '../../hooks/use-breakpoint-visibility.js';
import { withBreakpointVisibility } from '../../hocs/with-breakpoint-visibility.js';

const CmsRecentlyViewedProducts = ()=>{
    const siteLogos = useBloomreachSiteLogos();
    const pageName = useBloomreachPageName();
    return /*#__PURE__*/ React.createElement(RecentlyViewedProducts$1, {
        reimbursableLogos: {
            default: siteLogos.reimbursable,
            alternative: siteLogos.reimbursableAlternative
        },
        renderLocation: pageName
    });
};
var RecentlyViewedProducts = compose(withBreakpointVisibility, withAnchor)(CmsRecentlyViewedProducts);

export { CmsRecentlyViewedProducts, RecentlyViewedProducts as default };
//# sourceMappingURL=RecentlyViewedProducts.js.map
